module.exports = __webpack_public_path__ + "img/team-4.31354181.jpg";